<template>
  <section class="section">
    <h1 class="title">Job</h1>
    <form @submit.prevent="submit">
      <b-input v-model="bookingId" type="hidden" />
      <b-input v-model="editClientCode" type="hidden" />
      <b-input v-model="editAccountCode" type="hidden" />
      <b-input v-model="editAccountName" type="hidden" />
      <b-input v-model="scheduledDate" type="hidden" />
      <div v-if="errors.length" class="column is-one-third">
        <b>Please correct the following error(s):</b>
        <ul>
          <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
        </ul>
      </div>
      <div class="columns">
        <div class="column is-half">
          <!-- <b-field grouped> -->
          <div class="columns">
            <div class="column is-one-third">
              <b-field label="Status" custom-class="labelCharge">
                <b-select
                  placeholder="Select status"
                  v-model="status"
                  required
                  expanded
                >
                  <option
                    v-for="(status, index) in statuses"
                    :key="index"
                    :value="status.id"
                  >
                    {{ status.name }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-two-thirds">
              <b-field label="Charge To" custom-class="labelCharge">
                <b-select
                  placeholder="Select client"
                  v-model="clientCode"
                  id="selClient"
                  @input="onChangeClient($event)"
                  expanded
                >
                  <option
                    v-for="(client, index) in clients"
                    :key="index"
                    :value="{
                      ccode: client.clientCode,
                      acode: client.accountCode,
                      cname: client.clientName
                    }"
                  >
                    <!-- {{
                    client.accountCode +
                      ":" +
                      client.clientName +
                      " (" +
                      client.clientCode +
                      ")"
                  }} -->
                    {{ client.clientCode }} ({{ client.clientName }})
                    {{ client.accountCode }}
                  </option>
                </b-select>
              </b-field>
              <!-- </b-field> -->
            </div>
          </div>

          <!-- <b-field
              label="Client Details"
              custom-class="labelCharge"
              v-if="showClient"
            >
              {{ clientInfo }}
            </b-field> -->
        </div>
        <div class="column is-half">
          <b-field label="Job Type" class="has-check">
            <radio-picker
              :options="{
                pickup: 'Pickup From Client',
                delivery: 'Deliver To Client',
                farm: 'Farm To Farm'
              }"
              v-model="jobType"
            ></radio-picker>
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column is-half">
          <b-field label="Pickup" custom-class="labelCharge">
            <b-select
              placeholder="Select address"
              v-model="pickup"
              required
              expanded
            >
              <option
                v-for="(address, index) in addresses"
                :key="index"
                :value="address.addressName"
              >
                {{ address.address }}
              </option>
            </b-select>
          </b-field>
        </div>

        <div class="column is-half">
          <b-field label="Desination" custom-class="labelCharge">
            <b-select
              placeholder="Select address"
              v-model="destination"
              required
              expanded
            >
              <option
                v-for="(address, index) in addresses"
                :key="index"
                :value="address.addressName"
              >
                {{ address.address }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>

      <div class="columns">
        <div class="column is-half">
          <b-field label="Customer" custom-class="labelCharge">
            <b-input v-model="customer" required />
          </b-field>
        </div>
        <div class="column is-half">
          <b-field label="Customer Phone" custom-class="labelCustomer">
            <b-input v-model="phone" required />
          </b-field>
        </div>
      </div>

      <div class="columns">
        <div class="column is-half">
          <b-field label="Price Charged" custom-class="weight" expanded>
            <b-input
              step="0.01"
              min="0"
              v-model="charged"
              type="number"
            ></b-input>
          </b-field>
        </div>
        <div class="column is-half">
          <b-field label="Notes" custom-class="labelCharge">
            <b-input type="textarea" v-model="notes"></b-input>
          </b-field>
        </div>
      </div>
      <hr />

      <h2 class="title is-4">Product</h2>
      <b-field grouped class="is-grouped-multiline">
        <b-field label="Type" custom-class="labelCharge">
          <b-select
            placeholder="Select product"
            v-model="product"
            required
            @input="onChangeProduct($event)"
            expanded
          >
            <option
              v-for="(product, index) in products"
              :key="index"
              :value="product.productName"
            >
              {{ product.productName }}
            </option>
          </b-select>
        </b-field>

        <b-field label="Quantity" expanded>
          <b-input step="1" min="0" v-model="qty" type="number"></b-input>
        </b-field>

        <b-field label="Rate" expanded>
          <b-input step="0.1" min="0" v-model="rate" type="number"></b-input>
        </b-field>

        <b-field label="Unit" expanded>
          <b-input type="text" v-model="unit"></b-input>
        </b-field>

        <b-field label="Est KM" custom-class="addJob" expanded>
          <b-input step="1" min="0" v-model="km" type="number"></b-input>
        </b-field>

        <b-field label="Est Weight" custom-class="weight" expanded>
          <b-input step="1" min="0" v-model="weight" type="number"></b-input>
        </b-field>
      </b-field>

      <div class="columns">
        <div class="column is-half">
          <b-field label="Requested Pickup Time" custom-class="labelRequest">
            <b-datetimepicker
              rounded
              placeholder="Click to select..."
              icon="calendar-today"
              horizontal-time-picker
              v-model="pickupDate"
              required
            >
            </b-datetimepicker>
          </b-field>
        </div>
        <div class="column is-half">
          <b-field
            label="Requested Delivery Time"
            custom-class="labelRequestDelivery"
          >
            <b-datetimepicker
              rounded
              placeholder="Click to select..."
              icon="calendar-today"
              horizontal-time-picker
              v-model="deliveryDate"
              required
            >
            </b-datetimepicker>
          </b-field>
        </div>
      </div>

      <h2 class="title is-4">Assignment</h2>
      <div class="columns">
        <div class="column is-half">
          <b-field label="Truck" custom-class="labelCharge">
            <b-select placeholder="Select truck" v-model="selTruck" expanded>
              <option
                v-for="(truck, index) in trucks"
                :key="index"
                :value="truck.name"
              >
                {{ truck.description }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-half">
          <b-field label="Driver" custom-class="labelCharge">
            <b-select
              placeholder="Select driver"
              v-model="selDriver"
              id="selDriver"
              expanded
            >
              <option
                v-for="(driver, index) in drivers"
                :key="index"
                :value="driver.email"
              >
                {{ driver.name + " " + driver.surname }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>

      <h1 class="title is-4">Loads</h1>
      <b-field label="New Load" custom-class="labelCharge">
        <b-input v-model="newLoad" />
      </b-field>

      <b-field label="Exisiting Load" custom-class="labelCharge">
        <b-select placeholder="Select Load" v-model="selLoad">
          <option
            v-for="(load, index) in allLoads"
            :key="index"
            :value="load.name"
          >
            {{ load.name }}
          </option>
        </b-select>
      </b-field>

      <hr />
      <b-field>
        <b-field grouped>
          <div class="control">
            <b-button native-type="submit" type="is-primary">Submit</b-button>
          </div>
          <!--<div class="control">
                <b-button type="is-primary is-outlined" @click="reset">Reset</b-button>
              </div>-->
        </b-field>
      </b-field>
    </form>
  </section>
  <!-- </card-component>
    </section>
  </div> -->
</template>

<script>
import RadioPicker from "@/components/RadioPicker";
// import CardComponent from "@/components/CardComponent";
import axios from "axios";

// import HeroBar from "@/components/HeroBar";
export default {
  name: "Forms",
  components: { RadioPicker },
  data() {
    return {
      bookingId: 0,
      isLoading: false,
      isImageModalActive: false,
      selected: null,
      name: null,
      email: null,
      phone: null,
      customer: null,
      status: 1,
      subject: null,
      notes: null,
      products: [],
      qty: 0,
      km: 0,
      unit: null,
      rate: null,
      weight: 0,
      product: null,
      charged: 0,
      load: "",
      jobType: "pickup",
      requestedPickup: new Date(),
      pickupDate: new Date(),
      deliveryDate: new Date(),
      clientCode: null,
      pickup: null,
      destination: null,
      clientInfo: null,
      showClient: false,
      editClientCode: null,
      editAccountCode: null,
      editAccountName: null,
      scheduledDate: "",
      drivers: [],
      newLoad: "",
      selLoad: [],
      selDriver: [],
      statuses: [
        { id: 1, name: "Pending" },
        { id: 2, name: "Booked" },
        { id: 3, name: "In Transit" },
        { id: 4, name: "Delivered" },
        { id: 5, name: "Completed" }
      ],
      selTruck: null,
      trucks: [],
      truck: null,
      addresses: [],
      address: null,
      clients: [],
      client: null,
      errors: [],
      allLoads: [],
      loads: []
    };
  },
  computed: {},
  methods: {
    submit(e) {
      var errorFound = false;

      this.errors = [];
      if (this.editClientCode === null) {
        if (document.getElementById("selClient").value === "") {
          this.errors.push("Charge To is required");
          errorFound = true;
        }
      }
      if (this.newLoad !== "") {
        var x = "";
        var current = false;
        for (x in this.allLoads) {
          if (this.newLoad === this.allLoads[x].name) {
            current = true;
          }
        }
        if (current) {
          this.errors.push("This load name already exists.");
          errorFound = true;
        }
      }
      if (this.newLoad === "" && this.selLoad === "") {
        this.errors.push(
          "A new load needs to be added to the job or select an existing load"
        );
        errorFound = true;
      } else {
        if (this.newLoad !== "") {
          this.load = this.newLoad;
        } else {
          this.load = this.selLoad;
        }
      }
      if (!this.product.length > 0) {
        this.errors.push("A product needs to be added to the job");
        errorFound = true;
      }
      if (this.pickupDate.getTime() > this.deliveryDate.getTime()) {
        this.errors.push(
          "The Requested Delivery time needs to be after the Requested Pickup time"
        );
        errorFound = true;
      }

      if (this.errors.length > 0) {
        return true;
      }

      e.preventDefault();

      if (!errorFound) {
        if (this.saveJob()) {
          setTimeout(() => {
            this.isLoading = false;
            this.$buefy.snackbar.open({
              message: "Job has been saved",
              queue: false
            });
          }, 500);
        }
      }
    },
    onChangeProduct(productName) {
      var product = this.products.filter(function(search) {
        return search.productName === productName;
      });
      this.unit = product[0].defaultUnit;
      this.rate = product[0].defaultRate;
    },
    async saveJob() {
      if (this.bookingId > 0) {
        this.putJob();
      } else {
        this.postJob();
      }
    },
    async putJob() {
      try {
        var dest = this.destination;
        this.destAddress = this.addresses.filter(function(addr) {
          return addr.addressName === dest;
        });
        var pickup = this.pickup;
        var pickupAddress = this.addresses.filter(function(addr) {
          return addr.addressName === pickup;
        });
        var updateClientCode = "";
        var updateAccountCode = "";
        var updateAccountName = "";
        if (this.editClientCode === null) {
          updateClientCode = this.clientCode.ccode;
          updateAccountCode = this.clientCode.acode;
          updateAccountName = this.clientCode.aname;
        } else {
          updateClientCode = this.editClientCode;
          updateAccountCode = this.editAccountCode;
          updateAccountName = this.editAccountName;
        }
        var dName = document.getElementById("selDriver");

        await axios.put(
          this.$store.state.apiUrl + "transport/" + this.bookingId,
          {
            action: "TbPutTransportBooking",
            changedFields: {
              clientCode: updateClientCode,
              accountCode: updateAccountCode,
              accountName: updateAccountName,
              loadName: this.load,
              pickupAddress: {
                addressName: pickupAddress[0].addressName,
                address: pickupAddress[0].address,
                town: pickupAddress[0].town,
                postcode: pickupAddress[0].postcode,
                gps: pickupAddress[0].gps,
                pic: pickupAddress[0].pic,
                columnPrefix: pickupAddress[0].columnPrefix
              },
              destinationAddress: {
                addressName: this.destAddress[0].addressName,
                address: this.destAddress[0].address,
                town: this.destAddress[0].town,
                postcode: this.destAddress[0].postcode,
                gps: this.destAddress[0].gps,
                pic: this.destAddress[0].pic,
                columnPrefix: this.destAddress[0].columnPrefix
              },
              truckName: this.selTruck,
              driverId: this.selDriver,
              driverName: dName.options[dName.selectedIndex].text,
              requestedPickupTime: this.pickupDate,
              requestedDeliveryTime: this.deliveryDate,
              contact: this.customer,
              contactPhone: this.phone,
              notes: this.notes,
              qty: this.qty,
              status: this.status,
              productName: this.product,
              estimatedkm: this.km,
              estimatedWeight: this.weight,
              qtyType: this.unit,
              actualQty: 0,
              quotedPrice: this.rate,
              priceCharged: this.charged,
              invoiced: false,
              scheduledDate: this.scheduledDate
            }
          },
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
      } catch (error) {
        console.log(error);
      }
    },
    async postJob() {
      try {
        var dest = this.destination;
        this.destAddress = this.addresses.filter(function(addr) {
          return addr.addressName === dest;
        });
        var pickup = this.pickup;
        var pickupAddress = this.addresses.filter(function(addr) {
          return addr.addressName === pickup;
        });
        var dName = document.getElementById("selDriver");
        await axios
          .post(
            this.$store.state.apiUrl + "transport?mode=app",
            {
              clientCode: this.clientCode.ccode,
              accountCode: this.clientCode.acode,
              accountName: this.clientCode.cname,
              loadName: this.load,
              pickupAddress: {
                addressName: pickupAddress[0].addressName,
                address: pickupAddress[0].address,
                town: pickupAddress[0].town,
                postcode: pickupAddress[0].postcode,
                gps: pickupAddress[0].gps,
                pic: pickupAddress[0].pic,
                columnPrefix: pickupAddress[0].columnPrefix
              },
              destinationAddress: {
                addressName: this.destAddress[0].addressName,
                address: this.destAddress[0].address,
                town: this.destAddress[0].town,
                postcode: this.destAddress[0].postcode,
                gps: this.destAddress[0].gps,
                pic: this.destAddress[0].pic,
                columnPrefix: this.destAddress[0].columnPrefix
              },
              truckName: this.selTruck,
              driverId: this.selDriver,
              driverName: dName.options[dName.selectedIndex].text,
              requestedPickupTime: this.pickupDate,
              requestedDeliveryTime: this.deliveryDate,
              contact: this.customer,
              contactPhone: this.phone,
              notes: this.notes,
              qty: this.qty,
              status: this.status,
              productName: this.product,
              estimatedkm: this.km,
              estimatedWeight: this.weight,
              qtyType: this.unit,
              actualQty: 0,
              quotedPrice: this.rate,
              priceCharged: this.charged,
              invoiced: false
            },
            {
              headers: {
                Authorization: "Bearer " + this.$cookies.get("user_token"),
                "Content-Type": "application/json"
              }
            }
          )
          .then(response => {
            console.log(response);
          });
      } catch (error) {
        console.log(error);
      }
    },
    onChangeClient() {
      this.editClientCode = null;
      this.editAccountCode = null;
      if (this.jobType === "pickup" || this.jobType === "delivery") {
        this.getClient(this.clientCode.ccode, this.jobType);
      }
    },
    async getTransportProduct() {
      // Use Axios to make a call to the API
      try {
        const { data } = await axios.get(
          this.$store.state.apiUrl + "lookup/transport_product",
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
        this.products = data;
      } catch (error) {
        console.log(error);
      }
    },
    async getTrucks() {
      // Use Axios to make a call to the API
      try {
        const { data } = await axios.get(
          this.$store.state.apiUrl + "lookup/vehicle",
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
        this.trucks = data;
      } catch (error) {
        console.log(error);
      }
    },
    async getAddresses() {
      // Use Axios to make a call to the API
      try {
        const { data } = await axios.get(
          this.$store.state.apiUrl + "lookup/address",
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
        this.addresses = data;
        // this.addresses.sort((a, b) => a.addressName.localeCompare(b.addressName))
      } catch (error) {
        console.log(error);
      }
    },
    async getClients() {
      // Use Axios to make a call to the API
      try {
        const { data } = await axios.get(
          this.$store.state.apiUrl + "client_account/account_code_list",
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
        this.clients = data;
        // this.sortArrays()
      } catch (error) {
        console.log(error);
      }
    },
    async getClient(clientCode, addressType) {
      // Use Axios to make a call to the API
      try {
        const { data } = await axios.get(
          this.$store.state.apiUrl + "client/" + clientCode,
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token")
            }
          }
        );
        if (addressType === "pickup") {
          this.pickup = data[0].defaultAddress.addressName;
          this.destination = "";
        }
        if (addressType === "delivery") {
          this.destination = data[0].defaultAddress.addressName;
          this.pickup = "";
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getJob(bookingId) {
      // Use Axios to make a call to the API
      try {
        const { data } = await axios.get(
          this.$store.state.apiUrl +
            "transport/" +
            bookingId +
            "?mode=app&row_type=transport_booking",
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
        this.bookingId = data[0].bookingId;
        this.pickup = data[0].pickupAddress.addressName;
        this.destination = data[0].destinationAddress.addressName;
        this.selTruck = data[0].truckName;
        this.selDriver = data[0].driverId;
        this.status = data[0].status;
        this.selLoad = data[0].loadName;
        this.clientInfo =
          data[0].clientCode +
          " (" +
          data[0].accountName +
          ") " +
          data[0].accountCode;
        this.showClient = true;
        this.editClientCode = data[0].clientCode;
        this.editAccountCode = data[0].accountCode;
        this.editAccountName = data[0].accountName;
        this.clientCode = data[0].clientCode;
        this.phone = data[0].contactPhone;
        this.customer = data[0].contact;
        if (data[0].requestedPickupTime)
          this.pickupDate = new Date(data[0].requestedPickupTime);
        if (data[0].requestedDeliveryTime)
          this.deliveryDate = new Date(data[0].requestedDeliveryTime);
        this.qty = data[0].qty;
        this.product = data[0].productName;
        this.unit = data[0].qtyType;
        this.notes = data[0].notes;
        this.rate = data[0].quotedPrice;
        this.km = data[0].estimatedkm;
        this.weight = data[0].estimatedWeight;
        this.charged = data[0].priceCharged;
        this.scheduledDate = data[0].scheduledDate;
      } catch (error) {
        console.log(error);
      }
    },
    async getDrivers() {
      try {
        const { data } = await axios.get(
          this.$store.state.apiUrl + "user/userByRole/driver",
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
        this.drivers = data;
        // this.sortArrays()
      } catch (error) {
        console.log(error);
      }
    },
    async getLoads() {
      try {
        const { data } = await axios.get(
          this.$store.state.apiUrl +
            "transport?mode=app&row_type=transport_booking&orderby=day",
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
        var loadss = [];
        var i = 0;
        for (i = 0; i < data.length; i++) {
          this.loads.push({ name: data[i].loadName });
        }

        // we only give the drop down unique load names
        this.loads.filter(function(item) {
          var i = loadss.findIndex(x => x.name === item.name);
          if (i <= -1) {
            loadss.push({ name: item.name });
          }
          return null;
        });
        this.allLoads = loadss;
      } catch (error) {
        console.log(error);
      }
    }
  },
  created() {
    this.getTrucks();
    this.getAddresses();
    this.getClients();
    this.getTransportProduct();
    this.getDrivers();
    this.getLoads();
    if (this.$route.params.id) {
      this.getJob(this.$route.params.id);
    }
  }
};
</script>
